// document.addEventListener("DOMContentLoaded", function () {
    // Set the path to your Lottie JSON file
    if(typeof mapboxgl !== 'undefined'){
        mapboxgl.accessToken = 'pk.eyJ1IjoicGxhc3RlciIsImEiOiJjbG83YXM4YzAwM3ppMnFrYXp0dnFqNXhyIn0.Xhe6TD9mtCdNU0ep_PV-Ig';

        var map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/plaster/clo7bgoiz006r01pb5xjyh72n',
            center: [-0.0440858193299332, 51.513110638504145], // starting position [lng, lat]
            zoom: 14 // starting zoom
        });

        const geojson = {
            'type': 'FeatureCollection',
            'features': [
              {
                'type': 'Feature',
                    'properties' : {
                    'message'    : 'Stepney Methodist Church (Stop LL)',
                    'title'      : 'Stepney Methodist Church (Stop LL)',
                    'iconSize'   : [45, 45],
                    'markerClass': 'marker--bus'
                    },
                'geometry': {
                  'type'       : 'Point',
                  'coordinates': [-0.04291323373903023, 51.51313725736918] 
                }
              },
              {
                'type': 'Feature',
                    'properties' : {
                    'message'    : 'Marion Richardson School (Stop LM)',
                    'title'      : 'Marion Richardson School (Stop LM)',
                    'iconSize'   : [45, 45],
                    'markerClass': 'marker--bus'
                    },
                'geometry': {
                  'type'       : 'Point',
                  'coordinates': [-0.04599854372096299, 51.51323874983012] 
                }
              },
              {
                'type': 'Feature',
                    'properties' : {
                    'message'    : 'Limehouse Station (Stop LK)',
                    'title'      : 'Limehouse Station (Stop LK)',
                    'iconSize'   : [45, 45],
                    'markerClass': 'marker--bus'
                    },
                'geometry': {
                  'type'       : 'Point',
                  'coordinates': [-0.04020271548681599, 51.512822758659] 
                }
              },
              {
                'type': 'Feature',
                    'properties' : {
                    'message'    : 'Cable Street (Stop LR)',
                    'title'      : 'Cable Street (Stop LR)',
                    'iconSize'   : [45, 45],
                    'markerClass': 'marker--bus'
                    },
                'geometry': {
                  'type'       : 'Point',
                  'coordinates': [-0.04148294105463151, 51.512113276159816] 
                }
              },
              {
                'type': 'Feature',
                    'properties' : {
                    'message'    : 'Cable Street (Stop LS)',
                    'title'      : 'Cable Street (Stop LS)',
                    'iconSize'   : [45, 45],
                    'markerClass': 'marker--bus'
                    },
                'geometry': {
                  'type'       : 'Point',
                  'coordinates': [-0.041547314068277705, 51.51145891741952] 
                }
              },
              {
                'type': 'Feature',
                    'properties' : {
                    'message'    : 'Shadwell Station',
                    'title'      : 'Shadwell station',
                    'iconSize'   : [45, 45],
                    'markerClass': 'marker--train'
                    },
                'geometry': {
                    'type'       : 'Point',
                    'coordinates': [-0.05693662445880706, 51.51120751070319] 
                }
              },
              {
                'type': 'Feature',
                    'properties' : {
                    'message'    : 'Limehouse Station',
                    'title'      : 'Limehouse station',
                    'iconSize'   : [45, 45],
                    'markerClass': 'marker--train'
                    },
                'geometry': {
                    'type'       : 'Point',
                    'coordinates': [-0.03964965575819584, 51.51280324539633] 
                }
              },
              {
                'type': 'Feature',
                'properties' : {
                'message'    : 'Troxy',
                'title'      : 'Troxy',
                'iconSize'   : [60, 60],
                'markerClass': 'marker--venue'
                },
                'geometry': {
                'type'       : 'Point',
                'coordinates': [-0.0440858193299332, 51.513110638504145]
                }
                },
            ]
            };
            

        // Add markers to the map.
        for (const marker of geojson.features) {
        // Create a DOM element for each marker.
        const el = document.createElement('div');
        const width = marker.properties.iconSize[0];
        const height = marker.properties.iconSize[1];
        // el.className = 'marker';
        el.className = `marker ${marker.properties.markerClass}`;
        el.style.width = `${width}px`;
        el.style.height = `${height}px`;
        el.style.backgroundSize = '50%';
        el.style.backgroundRepeat = 'no-repeat';
        el.style.backgroundPosition = 'center'
        // console.log(el);

        // Add markers to the map.
        new mapboxgl.Marker(el)
        .setLngLat(marker.geometry.coordinates)
        .setPopup(new mapboxgl.Popup().setHTML(`<p data-type="${marker.properties.markerClass}">${marker.properties.title}</p>`))
        .addTo(map);
        }
    }
// })